import { Button, Card, Col, Form, message, Select } from "antd";
import React, { useEffect, useState } from "react";
import useBucketStore from "../../store";
import { studioApi } from "../../api";

const PdfBucketSetting = () => {
  const [loading, setLoading] = useState(false);
  const { buckets } = useBucketStore();
  const [defaultBucketForm] = Form.useForm();

  useEffect(() => {
    const savedBucket = localStorage.getItem("pdf_bucket");
    if (savedBucket) {
      defaultBucketForm.setFieldsValue({
        pdf_bucket: savedBucket,
      });
    }
  }, [defaultBucketForm]);

  const onFinish = async (values: any) => {
    const { pdf_bucket } = values;

    try {
      setLoading(true);
      await studioApi.post("settings", {
        name: "pdf_bucket",
        value: pdf_bucket,
      });
      message.success("Pdf Bucket created successfully");
      localStorage.setItem("pdf_bucket", pdf_bucket);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error saving pdf bucket:", error);
      message.error(error.response.data.message);
    }
  };

  return (
    <Col xs={24} sm={24} md={24} lg={24} xl={12} span={12}>
      <Form form={defaultBucketForm} layout="vertical" onFinish={onFinish}>
        <Card
          title="Pdf Bucket Setting"
          type="inner"
          extra={
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={loading}
            >
              Submit
            </Button>
          }
        >
          <Form.Item
            label="Select pdf bucket"
            name="pdf_bucket"
            rules={[
              {
                required: true,
                message: "Please select pdf bucket",
              },
            ]}
          >
            <Select
              showSearch
              placeholder="Select a bucket"
              style={{ width: "100%" }}
              options={buckets.map((val: any) => ({
                value: val._id,
                label: val.title,
              }))}
            />
          </Form.Item>
        </Card>
      </Form>
    </Col>
  );
};

export default PdfBucketSetting;
